// LE
import lePinDefault from './leDefault.png'
import lePinActive from './leActive.png'
import lePinPreviewed from './lePreviewed.png'

// Bedbank on LE
import leBedbankPinDefault from './bedbankDefault.png'
import leBedbankPinActive from './bedbankActive.png'
import leBedbankPinPreviewed from './bedbankPreviewed.png'

// Flash on LE
import leFlashPinDefault from './flashDefault.png'
import leFlashPinActive from './flashActive.png'
import leFlashPinPreviewed from './flashPreviewed.png'

// Sold out
import soldOutPinDefault from './soldOutDefault.png'
import soldOutPinDefaultHover from './soldOutDefaultHover.png'
import soldOutPinActive from './soldOutActive.png'
import soldOutPinPreviewed from './soldOutPreviewed.png'
import soldOutPinPreviewedHover from './soldOutPreviewedHover.png'

// LED (placeholder)
import pinUnbranded from './pinDefault.png'
import pinUnbrandedActive from './pinActive.png'

export interface PinSizing {
  size: [number, number];
  anchor: [number, number];
}

interface Pin {
  image: string;
  sizing: PinSizing;
}

interface PinType {
  default: Pin;
  hover: Pin;
}

interface PinConfig {
  pinIcons: {
    default: PinType;
    active: PinType;
    previewed: PinType;
  };
  flashPinIcons: {
    default: PinType;
    active: PinType;
    previewed: PinType;
  }
  bedbankPinIcons: {
    default: PinType;
    active: PinType;
    previewed: PinType;
  };
  soldOutPinIcons: {
    default: PinType;
    active: PinType;
    previewed: PinType;
  };
}

const leDefaultSize: PinSizing = {
  size: [41, 50], // Actual icon should be 38x47, but there's some empty space in the images
  anchor: [20, 46],
}

const leExpandSize: PinSizing = {
  size: [50, 60], // Actual icon should be 44x56, but there's some empty space in the images
  anchor: [25, 56],
}

const bedbankDefaultSize: PinSizing = {
  size: [35, 43], // Actual icon should be 32x40, but there's some empty space in the images
  anchor: [18, 40],
}

const bedbankExpandSize: PinSizing = {
  size: [39, 48], // Actual icon should be 36x45, but there's some empty space in the images
  anchor: [20, 45],
}

const soldOutDefaultSize: PinSizing = {
  size: [32, 38], // Actual icon should be 24x30, but there's some empty space in the images
  anchor: [16, 24],
}

const soldOutExpandSize: PinSizing = {
  size: [36, 43], // Actual icon should be 52x66, but there's some empty space in the images
  anchor: [18, 29],
}

const unbrandedSize: PinSizing = {
  size: [28, 31],
  anchor: [14, 28],
}

const unbrandedSmallSize: PinSizing = {
  size: [18, 20],
  anchor: [9, 18],
}

const brandPins: { [brand: string]: PinConfig } = {
  luxuryescapes: {
    pinIcons: {
      default: {
        default: {
          image: lePinDefault,
          sizing: leDefaultSize,
        },
        hover: {
          image: lePinActive,
          sizing: leExpandSize,
        },
      },
      active: {
        default: {
          image: lePinActive,
          sizing: leExpandSize,
        },
        hover: {
          image: lePinActive,
          sizing: leExpandSize,
        },
      },
      previewed: {
        default: {
          image: lePinPreviewed,
          sizing: leDefaultSize,
        },
        hover: {
          image: lePinActive,
          sizing: leExpandSize,
        },
      },
    },
    flashPinIcons: {
      default: {
        default: {
          image: leFlashPinDefault,
          sizing: leDefaultSize,
        },
        hover: {
          image: leFlashPinActive,
          sizing: leExpandSize,
        },
      },
      active: {
        default: {
          image: leFlashPinActive,
          sizing: leExpandSize,
        },
        hover: {
          image: leFlashPinActive,
          sizing: leExpandSize,
        },
      },
      previewed: {
        default: {
          image: leFlashPinPreviewed,
          sizing: leDefaultSize,
        },
        hover: {
          image: leFlashPinActive,
          sizing: leExpandSize,
        },
      },
    },
    bedbankPinIcons: {
      default: {
        default: {
          image: leBedbankPinDefault,
          sizing: bedbankDefaultSize,
        },
        hover: {
          image: leBedbankPinActive,
          sizing: bedbankExpandSize,
        },
      },
      active: {
        default: {
          image: leBedbankPinActive,
          sizing: bedbankExpandSize,
        },
        hover: {
          image: leBedbankPinActive,
          sizing: bedbankExpandSize,
        },
      },
      previewed: {
        default: {
          image: leBedbankPinPreviewed,
          sizing: bedbankDefaultSize,
        },
        hover: {
          image: leBedbankPinActive,
          sizing: bedbankExpandSize,
        },
      },
    },
    soldOutPinIcons: {
      default: {
        default: {
          image: soldOutPinDefault,
          sizing: soldOutDefaultSize,
        },
        hover: {
          image: soldOutPinDefaultHover,
          sizing: soldOutExpandSize,
        },
      },
      active: {
        default: {
          image: soldOutPinActive,
          sizing: soldOutExpandSize,
        },
        hover: {
          image: soldOutPinActive,
          sizing: soldOutExpandSize,
        },
      },
      previewed: {
        default: {
          image: soldOutPinPreviewed,
          sizing: soldOutDefaultSize,
        },
        hover: {
          image: soldOutPinPreviewedHover,
          sizing: soldOutExpandSize,
        },
      },
    },
  },
  default: {
    pinIcons: {
      default: {
        default: {
          image: pinUnbranded,
          sizing: unbrandedSize,
        },
        hover: {
          image: pinUnbranded,
          sizing: unbrandedSize,
        },
      },
      active: {
        default: {
          image: pinUnbrandedActive,
          sizing: unbrandedSize,
        },
        hover: {
          image: pinUnbrandedActive,
          sizing: unbrandedSize,
        },
      },
      previewed: {
        default: {
          image: pinUnbranded,
          sizing: unbrandedSize,
        },
        hover: {
          image: pinUnbranded,
          sizing: unbrandedSize,
        },
      },
    },
    flashPinIcons: {
      default: {
        default: {
          image: pinUnbranded,
          sizing: unbrandedSmallSize,
        },
        hover: {
          image: pinUnbranded,
          sizing: unbrandedSmallSize,
        },
      },
      active: {
        default: {
          image: pinUnbrandedActive,
          sizing: unbrandedSmallSize,
        },
        hover: {
          image: pinUnbrandedActive,
          sizing: unbrandedSmallSize,
        },
      },
      previewed: {
        default: {
          image: pinUnbranded,
          sizing: unbrandedSmallSize,
        },
        hover: {
          image: pinUnbranded,
          sizing: unbrandedSmallSize,
        },
      },
    },
    bedbankPinIcons: {
      default: {
        default: {
          image: pinUnbranded,
          sizing: unbrandedSmallSize,
        },
        hover: {
          image: pinUnbranded,
          sizing: unbrandedSmallSize,
        },
      },
      active: {
        default: {
          image: pinUnbrandedActive,
          sizing: unbrandedSmallSize,
        },
        hover: {
          image: pinUnbrandedActive,
          sizing: unbrandedSmallSize,
        },
      },
      previewed: {
        default: {
          image: pinUnbranded,
          sizing: unbrandedSmallSize,
        },
        hover: {
          image: pinUnbranded,
          sizing: unbrandedSmallSize,
        },
      },
    },
    soldOutPinIcons: {
      default: {
        default: {
          image: pinUnbranded,
          sizing: unbrandedSmallSize,
        },
        hover: {
          image: pinUnbranded,
          sizing: unbrandedSmallSize,
        },
      },
      active: {
        default: {
          image: pinUnbrandedActive,
          sizing: unbrandedSmallSize,
        },
        hover: {
          image: pinUnbrandedActive,
          sizing: unbrandedSmallSize,
        },
      },
      previewed: {
        default: {
          image: pinUnbranded,
          sizing: unbrandedSmallSize,
        },
        hover: {
          image: pinUnbranded,
          sizing: unbrandedSmallSize,
        },
      },
    },
  },
}

export default brandPins
